<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Configura galerias de Arquivos por tela</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="ConfigArq.laiId" label="Id" variant="outlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" v-if="ListaTelas!=''">
                                    <v-select v-model="ConfigArq.ctiId" label="Telas" :items="ListaTelas"
                                        item-title="ctiNome" item-value="ctiId" variant="outlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="ConfigArq.laiNome" :rules="nameRules" :counter="200"
                                        label="Nome Galeria" variant="outlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field v-model="ConfigArq.laiOrdem" label="Ordem" type="number"
                                        variant="outlined"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="ConfigArq.laiVisivel" label="Visível" :items="Status"
                                        item-title="nome" item-value="laiVisivel" variant="outlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="ConfigArq.laiPesoMb" label="Peso em MB" type="number"
                                        variant="outlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="ConfigArq.laiQtd" label="Quantidade" type="number"
                                        variant="outlined"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="ConfigArq.laiId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="outlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(ConfigArqs)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-laiVisivel="item">
                            <span>{{ item.laiVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-laiOrdem="item">
                            <span>{{ parseInt(item.laiOrdem) }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'ConfigListaArquivosView',
    components: {
        EasyDataTable
    },
    data: () => ({
        ConfigArq: {
            laiId: 0,
            ctiId: '',
            laiNome: '',
            laiOrdem: '',
            laiVisivel: '',
            laiQtd: '',
            laiPesoMb: '',
        },
        ConfigArqs: [],
        ListaTelas:[],
        selectedVisivel: null,
        Status: [{ nome: "Sim", laiVisivel: true }, { nome: "Não", laiVisivel: false }],
        nameRules: [
            value => {
                if (value?.length <= 200) return true
                return 'Nome pode conter até 200 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "laiId", sortable: true, },
            { text: "Tela", value: "admCadastroTelasInst.ctiNome", sortable: true, },
            { text: "Nome", value: "laiNome", sortable: true, },
            { text: "Ordem", value: "laiOrdem", sortable: true, },
            { text: "Visivel", value: "laiVisivel" },
            { text: "Qtde", value: "laiQtd" },
            { text: "Peso Max", value: "laiPesoMb" },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                laiOrdem: parseInt(item.laiOrdem),
            };
            });
        },
        Limpar() {
            this.ConfigArq.laiId = 0;
            this.ConfigArq.ctiId = "";
            this.ConfigArq.laiNome = "";
            this.ConfigArq.laiOrdem = "";
            this.ConfigArq.laiVisivel = "";
            this.ConfigArq.laiPesoMb = "";
            this.ConfigArq.laiQtd = "";
            this.selectedVisivel = "";
            this.Get();
        },
        Add() {
            if (this.ConfigArq.laiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ConfigArq.laiOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.ConfigArq.laiVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ConfigArq.ctiId == ''){
                this.$mensagemAviso("Tela obrigatória.")
            }
            else if (this.ConfigArq.laiPesoMb == ''){
                this.$mensagemAviso("Peso Obrigatório.")
            }
            else if (this.ConfigArq.laiQtd === ''){
                this.$mensagemAviso("Quantidade Obrigatório.")
            }
            else {
                this.ConfigArq.laiOrdem = parseInt(this.ConfigArq.laiOrdem)
                this.ConfigArq.laiPesoMb = parseInt(this.ConfigArq.laiPesoMb)
                this.ConfigArq.laiQtd = parseInt(this.ConfigArq.laiQtd)
                this.ConfigArq.AdmCadastroTelasInst = { ctiId: this.ConfigArq.ctiId};
                axios.post(`/Process/InsListaGaleriaInstArquivos/Add`, this.ConfigArq)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.ConfigArq.laiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ConfigArq.laiOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.ConfigArq.laiVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ConfigArq.ctiId == ''){
                this.$mensagemAviso("Tela obrigatória.")
            }
            else if (this.ConfigArq.laiPesoMb == ''){
                this.$mensagemAviso("Largura Obrigatório.")
            }
            else if (this.ConfigArq.laiQtd === ''){
                this.$mensagemAviso("Quantidade Obrigatório.")
            }
            else {
                this.ConfigArq.laiOrdem = parseInt(this.ConfigArq.laiOrdem)
                this.ConfigArq.laiPesoMb = parseInt(this.ConfigArq.laiPesoMb)
                this.ConfigArq.laiQtd = parseInt(this.ConfigArq.laiQtd)
                this.ConfigArq.AdmCadastroTelasInst = { ctiId: this.ConfigArq.ctiId};
                axios.put(`/Process/InsListaGaleriaInstArquivos/Update`, this.ConfigArq)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.ConfigArq = item;
            this.ConfigArq.ctiId = item.admCadastroTelasInst.ctiId
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.laiId;
                axios.delete(`/Process/InsListaGaleriaInstArquivos/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            
            axios.get(`Process/AdmCadastroTelasInst/GetTelasListaArquivos`)
                .then(response => {
                    this.ListaTelas = response.data;
                });

                axios.get(`/Process/InsListaGaleriaInstArquivos/GetAll`)
                .then(response => {
                    this.ConfigArqs = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
